import {useEffect, useState} from 'react'
import supabase from '../config/supabaseClient';

import HeroBanner from '../components/LandingPage/HeroBanner'
import Schedule from '../components/LandingPage/Schedule'
import Nav from '../components/LandingPage/MainNav'
import Announcements from '../components/LandingPage/Announcements'
import Sacraments from '../components/LandingPage/Sacraments'
import FeedBack from '../components/LandingPage/FeedBack'
import SafeEnvironment from '../components/LandingPage/SafeEnvironment'
import PhotoGallery from '../components/LandingPage/PhotoGallery'
import LogOut from '../components/LogOut'
// import { useNavigate } from 'react-router-dom';



import '../modules/LandingPageStyles.css'





function LandingPage() {

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const user = await supabase.auth.getUser();
      setIsAuthenticated(!!user.data.user);
      console.log("Auth!!", !!user.data.user);
    };
    checkAuth();
  }, []);

//   const navigate = useNavigate();
//   const goToDashboard = () => {
//     navigate('/dashboard')
// }

  return (
    <div className='LandingPage-PageView'>
     
      {isAuthenticated && (
        <div className="admin-notice">
          <h1 className="admin-title">You are signed in as Administrator!</h1>
          <p>You can manage the website content from the here.</p>
          <LogOut />
          <button className='MainBTN' onClick={() => window.location.href = '/dashboard'}>View Baptism</button>
          {/* <button className='MainBTN' onClick={goToDashboard}>Dashboard</button> */}
        </div>
      )}
      <HeroBanner />
      <Schedule />
      <Announcements />
      <Sacraments />
      <PhotoGallery />
      <SafeEnvironment />
      <Nav />
      <FeedBack />
    </div>
  )
}


export default LandingPage
